import { render, staticRenderFns } from "./ContaParaRecebimento.vue?vue&type=template&id=51764c9a&scoped=true"
import script from "./ContaParaRecebimento.vue?vue&type=script&lang=js"
export * from "./ContaParaRecebimento.vue?vue&type=script&lang=js"
import style0 from "./ContaParaRecebimento.vue?vue&type=style&index=0&id=51764c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51764c9a",
  null
  
)

export default component.exports